import {useDebugValue, useEffect, useRef} from 'react';

export function useBroadcastChannel(name, callback) {
    useDebugValue(name);
    const broadcastChannel = useRef();

    useEffect(() => {
        if ('BroadcastChannel' in window) {
            broadcastChannel.current = new BroadcastChannel(name);

            return () => {
                broadcastChannel.current.close();
                broadcastChannel.current = null;
            };
        }
    }, [name]);

    useEffect(() => {
        if (broadcastChannel.current) {
            broadcastChannel.current.onmessage = callback;
        }
    }, [callback]);
}
